export default "__VITE_ASSET__BPG9dwLo__"